module.exports = __webpack_public_path__ + "assets/img/Affiches_010.f18237f5.jpg";